import axios from 'axios'
import { clone, roundXDecimals, getWorkingDays, deleteKeyNullValues, objectCamelToSnakeCase, objectSnakeToCamelCase } from '@/util/libUtil.js'


const state = {
	dateActualInmutable: new Date(new Date().toISOString().substr(0, 7)),
	reportTable: {
		objetivos: [],
		rewards: [],
		isLoadingObjetivos: false,
		isLoadingRewards: false,
		date: new Date().toISOString().substr(0, 7),
		filtersComercial: {
			estado: 'ALTA',
		},
	},
	isOpenReportDateFilter: false,
	isOpenComercialFilterDialog: false,
	paths: {
		objetivoPath: '/api/calculadora/objetivo_mes/',
		bolsaPath: '/api/calculadora/bolsa_mes/',
	}
}

const mutations = {
	isLoadingObjetivos(state, payload) {
		state.reportTable.isLoadingObjetivos = payload
	},
	isLoadingStats(state, payload) {
		state.reportTable.isLoadingStats = payload
	},
	isLoadingRewards(state, payload) {
		state.reportTable.isLoadingRewards = payload
	},
	filtersComercial(state, val) {
		state.reportTable.filtersComercial = val
	},
	isOpenComercialFilterDialog(state, val) {
		state.isOpenComercialFilterDialog = val
	},
	date: (state, val) => {
		state.reportTable.date = val
	},
	isOpenReportDateFilter: (state, val) => {
		state.isOpenReportDateFilter = val
	},
	reportTable: (state, val) => {
		state.reportTable = clone(val)
	},
}

const actions = {
	async fetchObjetivo({ state, getters, dispatch, commit, rootState, rootGetters }, { soldOut = false }) {
		commit('isLoadingObjetivos', true)
		let paramsProcess = {
			'month_year_updated_on': state.reportTable.date, ...objectCamelToSnakeCase(deleteKeyNullValues(state.reportTable.filtersComercial))
		}
		if (soldOut) paramsProcess['sold_out'] = soldOut

		try {
			let resp = await axios.get(getters.getEndpointFromPath(state.paths.objetivoPath), {
				params: paramsProcess
			})

			commit('reportTable', {
				...state.reportTable, ...objectSnakeToCamelCase({ objetivos: resp.data })
			})
		} catch {
			dispatch('util/showStatusSnackBar', {
				statusType: 'error',
				message: 'Error al obtener el reporte'
			}, { root: true })
		}
		commit('isLoadingObjetivos', false)
	},
	async fetchBolsa({ state, getters, dispatch, commit, rootState, rootGetters }, { soldOut = false }) {
		commit('isLoadingRewards', true)

		let paramsProcess = {
			'month_year_updated_on': state.reportTable.date, ...objectCamelToSnakeCase(deleteKeyNullValues(state.reportTable.filtersComercial))
		}
		if (soldOut) paramsProcess['sold_out'] = soldOut

		try {
			let resp = await axios.get(getters.getEndpointFromPath(state.paths.bolsaPath), {
				params: paramsProcess
			})

			commit('reportTable', {
				...state.reportTable, ...objectSnakeToCamelCase({ rewards: resp.data })
			})
		} catch {
			dispatch('util/showStatusSnackBar', {
				statusType: 'error',
				message: 'Error al obtener las bolsas'
			}, { root: true })
		}
		commit('isLoadingRewards', false)
	}
}

const getters = {
	definePropertyObjetivos: (state, getters, rootState) => (objetivos) => {
		objetivos.forEach(obj => {
			Object.defineProperty(obj, "objetivo_porc", {
				get: function () {
					if (obj.objetivo == 0) {
						return ''
					}
					return roundXDecimals(obj.consecucion / obj.objetivo * 100, 2)
				},
				set: function () { }
			});
			Object.defineProperty(obj, "comision_porc", {
				get: function () {
					if (obj.objetivo == 0) {
						return 0
					}
					if (obj.objetivo_porc > rootState.areaPersonal.calculadora.maxPorcentaje) {
						return roundXDecimals(rootState.areaPersonal.calculadora.maxPorcentaje * obj.peso / 100, 2)
					} else {
						return roundXDecimals(obj.objetivo_porc * obj.peso / 100, 2)
					}
				},
				set: function () { }
			});
			Object.defineProperty(obj, "five_percent", {
				get: function () {
					if (obj.objetivo == 0) {
						return -1
					}

					const diasLaborablesMes = getWorkingDays(new Date(state.reportTable.date));
					let diasLaborablesHastaHoy = null;

					if (new Date(state.reportTable.date) < state.dateActualInmutable) {
						diasLaborablesHastaHoy = diasLaborablesMes;
					} else {
						diasLaborablesHastaHoy = getWorkingDays(new Date(state.reportTable.date), true);
					}

					const objetivoDia = obj.objetivo / diasLaborablesMes;
					const objetivoHastaHoy = (objetivoDia * diasLaborablesHastaHoy);

					return objetivoHastaHoy.toFixed(2);
				},
				set: function () { }
			});
		})
	},
	getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
		rootState.general.host + endpoint
	),
	currentNameMonthYear: (state) => {
		return `${state.reportTable.date.toLocaleString('es', {
			month: 'long',
			year: 'numeric',
		})}`;
	},
}

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}


